import React, { useState, useEffect } from "react";
import moment from "moment";
import "./ListsProgrammes.css";
import useFavorites from "../../../utils/useFavorites";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProgrammes,
  fetchSingleProgram,
  hideShowProgramme,
} from "../../../redux/actions/immobilierActions";
import { imageLoader } from "../../../utils/imageLoader";
import { openModal } from "../../../redux/actions/modalActions";
import HideProgram from "./HideProgram";

const ListeProgrammes = ({
  listeDesProgrammes,
  filterInput,
  ongletType,
  ongletId,
  query,
  sortConfig,
  setSortConfig,
}) => {
  const { user } = useSelector((state) => state.userAuthReducer);
  console.log(user.profile === "Administrateur");
  console.log(user.canHideShowProgramme);
  const dispatch = useDispatch();
  const { isProgramInFavorites, handleAddToFavorites } = useFavorites();
  // Add state for tracking window size
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const showImages = windowWidth >= 1440;

  // Function to get random badge color
  const getBadgeColor = (index) => {
    const colors = [
      "bg-green",
      "bg-blue",
      "bg-purple",
      "bg-orange",
      "bg-pink",
      "bg-yellow",
      "bg-red",
    ];
    return colors[index % colors.length];
  };

  // Add effect to update window size on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleProgrammeClick = (programmeId) => {
    dispatch(fetchSingleProgram(programmeId));
  };

  // Function to handle sort request
  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    // Map UI keys to API field names
    let sortField = key;
    if (key === "name") {
      sortField = "name";
    } else if (key === "delivery_date") {
      sortField = "delivery_date";
    } else if (key === "is_actable") {
      sortField = "is_actable";
    }
    // Dispatch action to fetch sorted programmes with the direction parameter
    dispatch(
      fetchProgrammes(
        {
          ...query,
          search: filterInput,
          page: 1,
          sort: sortField,
          direction: direction,
        },
        ongletType,
        ongletId
      )
    );
  };

  const handleShowHideProgram = (programme) => {
    dispatch(hideShowProgramme(programme.documentId, !programme.hidden)).then(
      () => {
        dispatch(
          fetchProgrammes(
            {
              ...query,
              search: filterInput,
              page: 1, // Reset to first page on new search
              sort: sortConfig.key,
              direction: sortConfig.direction,
            },
            ongletType,
            ongletId
          )
        );
      }
    );
  };

  // Helper function to render sort indicator
  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) {
      return <img src="/icons/sorts.svg" alt="sort" className="sort-icon" />;
    }
    return sortConfig.direction === "asc" ? (
      <img
        src="/icons/sort_up.svg"
        alt="sort ascending"
        className="sort-icon"
      />
    ) : (
      <img
        src="/icons/sort_down.svg"
        alt="sort descending"
        className="sort-icon"
      />
    );
  };
  const handleProgrammeImageClick = (e, programme) => {
    e.stopPropagation();
    const imageUrl =
      programme?.lots[0]?.images?.[1]?.image?.[0]?.url ||
      programme?.lots[0]?.images?.[0]?.image?.[0]?.url;

    if (imageUrl) {
      const title = `${programme.name} - Image du programme`;

      const content = (
        <img
          src={imageLoader(imageUrl)}
          alt={`Image du programme ${programme.name}`}
          style={{
            width: "100%",
            height: "auto",
            maxHeight: "80vh",
            objectFit: "contain",
            borderRadius: "8px",
          }}
        />
      );

      dispatch(openModal({ title, content }));
    }
  };
  return (
    <div className="p-0">
      <div className="tableR mt-4">
        {/* Header */}
        <div className="table-programme-header pink text-center">
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("name")}
            title="Nom du programme"
          >
            <img
              src="./icons/programmes.svg"
              width={30}
              height={30}
              alt="Programme"
            />{" "}
            {getSortIndicator("name")}
          </div>
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("delivery_date")}
            title="Date de livraison prévue"
          >
            <img
              src="./icons/delivery.svg"
              width={30}
              height={30}
              alt="Livraison"
            />{" "}
            {getSortIndicator("delivery_date")}
          </div>
          <div
            className="table-cells pink semibold sortableHeaderStyle"
            onClick={() => requestSort("is_actable")}
            title="Statut d'actabilité du programme"
          >
            <img
              src="./icons/actabilite.svg"
              width={30}
              height={30}
              alt="Actabilité"
            />{" "}
            {getSortIndicator("is_actable")}
          </div>
          <div
            className="table-cells pink semibold"
            title="Dispositifs fiscaux applicables"
          >
            <img
              src="./icons/project-types.svg"
              width={30}
              height={30}
              alt="Dispositif"
            />{" "}
            {getSortIndicator("is_actable")}
          </div>
          <div
            className="table-cells pink semibold"
            title="Nombre de lots disponibles"
          >
            <img
              src="./icons/lot-dispo.svg"
              width={30}
              height={30}
              alt="Lots dispo"
            />
          </div>
          <div className="table-cells pink semibold" title="">
            <img
              src="./icons/typologie.svg"
              width={30}
              height={30}
              alt="Typologie"
            />
          </div>
          <div
            className="table-cells pink semibold"
            title="Fourchette de prix des biens"
          >
            <img src="./icons/prix.svg" width={30} height={30} alt="Prix" />
          </div>
          <div
            className="table-cells pink semibold"
            title="Ajouter aux favoris"
          >
            <img
              src="./icons/favoris.svg"
              width={30}
              height={30}
              alt="Favoris"
            />
          </div>
        </div>

        {/* Rows */}
        {listeDesProgrammes.map((programme) => (
          <div
            key={programme.documentId}
            className="tables-rows cursor-pointer hoverborder position-relative"
            onClick={() => handleProgrammeClick(programme.documentId)}
            style={{
              backgroundColor:
                user.profile === "Administrateur" || user.canHideShowProgramme
                  ? programme.hidden
                    ? "rgba(237, 101, 163,0.3)"
                    : "#fff"
                  : "#fff",
            }}
          >
            {" "}
            {user.profile === "Administrateur" || user.canHideShowProgramme ? (
              <HideProgram
                programme={programme}
                handleShowHideProgram={handleShowHideProgram}
              />
            ) : null}
            {/* Programme */}
            <div className="table-cells p-0">
              <div className="d-flex align-items-center gap-3 p-0">
                {showImages && (
                  <div
                    className="program-image"
                    onClick={(e) => handleProgrammeImageClick(e, programme)}
                  >
                    <img
                      src={
                        programme.lots[0]?.images?.[1]?.image?.[0]?.url
                          ? imageLoader(
                              programme.lots[0].images[1].image[0].url
                            )
                          : programme.lots[0]?.images?.[0]?.image?.[0]?.url
                          ? imageLoader(
                              programme.lots[0].images[0].image[0].url
                            )
                          : imageLoader(programme.promoteur?.logo?.url)
                      }
                      alt="appart"
                      className="radius5"
                    />
                  </div>
                )}
                <div className="d-flex flex-column text-start gap16">
                  <div>
                    <p
                      className="mb-0 fs16 darkGrey semibold name-column"
                      title={programme.name}
                    >
                      {programme.name}
                    </p>
                    <p className="text-muted mb-0 fs11 darkGrey regular">
                      {programme.address || "NC"}
                    </p>
                  </div>
                  <div>
                    <p className="mb-0 fs11 darkGrey semibold">
                      {programme.city?.name || "NC"}
                    </p>
                    <p className="text-muted mb-0 fs11 darkGrey regular">
                      {programme.delivery_date
                        ? moment(programme.delivery_date).format("YYYY") +
                          " T-" +
                          moment(programme.delivery_date).quarter()
                        : "NC"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Livraison */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme.delivery_date
                ? moment(programme.delivery_date).format("YYYY") +
                  " T-" +
                  moment(programme.delivery_date).quarter()
                : "NC"}
            </div>
            {/* Actabilité */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme.is_actable ? "Immédiate" : "Pas Précisé"}
            </div>
            {/* Dispositif */}
            <div className="table-cells d-flex align-items-center justify-content-center">
              <div className="d-flex flex-column gap-2">
                {programme?.lots?.length > 0 &&
                programme.lots[0]?.project_types?.length > 0 ? (
                  programme.lots[0].project_types.map((projectType, index) => (
                    <span
                      key={projectType.documentId || index}
                      className={`badge ${getBadgeColor(index)}`}
                    >
                      {projectType.label}
                    </span>
                  ))
                ) : (
                  <span className="badge bg-green">NC</span>
                )}
              </div>
            </div>
            {/* Lots Dispo */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {programme?.lots?.length ? programme?.lots?.length : "NC"}
            </div>
            {/* Typologies */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center">
              {(() => {
                // Extract all unique typologies from the programme's lots, excluding "unknown"
                const typologies = programme?.lots?.reduce((acc, lot) => {
                  if (
                    lot.typology &&
                    lot.typology !== "unknown" &&
                    !acc.includes(lot.typology)
                  ) {
                    acc.push(lot.typology);
                  }
                  return acc;
                }, []);

                return typologies?.length > 0 ? typologies.join("-") : "NC";
              })()}
            </div>
            {/* Prix */}
            <div className="table-cells d-flex align-items-center justify-content-center">
              <div className="text-center">
                {programme?.lots?.length > 0 ? (
                  <>
                    <p className="text-muted fs16 semibold darkGrey">
                      De{" "}
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[0]?.price_total
                      ) + " €"}
                    </p>
                    <p className="mb-0 fs16 semibold darkGrey">
                      à{" "}
                      {Intl.NumberFormat("fr-FR").format(
                        programme?.lots[programme?.lots?.length - 1]
                          ?.price_total
                      ) + " €"}
                    </p>
                  </>
                ) : (
                  "NC"
                )}
              </div>
            </div>
            {/* Action */}
            <div className="table-cells text-center d-flex align-items-center justify-content-center ">
              <img
                src={
                  isProgramInFavorites(programme.documentId)
                    ? "./icons/favorite-filled.svg"
                    : "./icons/favorite-outline.svg"
                }
                alt="favorite"
                height={35}
                width={35}
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddToFavorites(programme.documentId, "Programme");
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListeProgrammes;
